import React from 'react';
import { PhoneDetails } from '../../../phone-details/phone-details';
import { IPhoneDetailProps } from './phone-detail.types';
import * as S from '../claim-timeline.styles';
import * as Card from './timeline-detail-card.styles';

export const PhoneDetail: React.FunctionComponent<IPhoneDetailProps> = (
    props: IPhoneDetailProps
): React.ReactElement => {
    const { phone, downloadDocument, transcribeDocument } = props;
    
    return (
        <Card.CdPanel $embedded key={phone.id}>
            <Card.CdSectionCard $embedded>
                <S.ExpandTable>
                    <S.ExpandTBody>
                        <S.ExpandTR>
                            <S.ExpandTH>ID</S.ExpandTH>
                            <S.ExpandTD>{phone.id}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Type</S.ExpandTH>
                            <S.ExpandTD>{phone.method}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Enter Representative</S.ExpandTH>
                            <S.ExpandTD>{phone.agent}</S.ExpandTD>
                        </S.ExpandTR>
                    </S.ExpandTBody>
                </S.ExpandTable>
            </Card.CdSectionCard>
            <Card.CdSectionCard $embedded>
                <PhoneDetails
                    phone={phone}
                    downloadDocument={downloadDocument}
                    transcribeDocument={transcribeDocument}
                />
            </Card.CdSectionCard>
        </Card.CdPanel>
    );
};
